<template>
    <main class="public-ko-tatou-shell">
        <section v-if="!hasAccess" class="pin-gate" aria-labelledby="pin-gate-title">
            <img src="../assets/Ko-Tatou.png" alt="Purapura Whetū" class="pin-gate-logo" />
            <h2 id="pin-gate-title">Ko Tātou Recovery Café Form</h2>
            <p>Please enter the PIN provided by a Ko Tātou kaimahi.</p>

            <q-form class="pin-form" @submit.prevent="unlockForm">
                <q-input
                    v-model="pin"
                    outlined
                    autofocus
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    type="password"
                    label="PIN"
                    :disable="checkingPin"
                    :error="Boolean(pinError)"
                    :error-message="pinError"
                    @update:model-value="pinError = ''"
                />
                <q-btn
                    type="submit"
                    unelevated
                    no-caps
                    size="lg"
                    label="Open form"
                    class="full-width ko-tatou-btn"
                    :loading="checkingPin"
                    :disable="!pin"
                />
            </q-form>
        </section>

        <section v-else class="public-form-card">
            <div class="public-form-actions">
                <q-btn
                    outline
                    no-caps
                    color="primary"
                    label="Exit form"
                    @click="exitForm"
                />
            </div>
            <DynamicFormRenderer
                ref="formRenderer"
                :form-id="13"
                :subject="anonymousSubject"
                :show-opt-out="false"
                public-mode
                @access-expired="handleAccessExpired"
                @form-submitted="handleSubmitted"
            />
        </section>
    </main>
</template>

<script>
import DynamicFormRenderer from "@/components/DynamicFormComponents/DynamicFormRenderer.vue";
import publicKoTatou from "@/services/api/publicKoTatou";
import { anonymousSubject } from "@/services/util/formSubject";

export default {
    name: "PublicKoTatou",
    components: { DynamicFormRenderer },
    data() {
        return {
            pin: "",
            pinError: "",
            checkingPin: false,
            hasAccess: Boolean(publicKoTatou.getAccessToken()),
            anonymousSubject: anonymousSubject(),
        };
    },
    methods: {
        async unlockForm() {
            this.checkingPin = true;
            this.pinError = "";
            try {
                await publicKoTatou.requestAccess(this.pin);
                this.pin = "";
                this.hasAccess = true;
            } catch (error) {
                this.pinError = error.response?.data?.message || "The PIN could not be checked. Please try again.";
            } finally {
                this.checkingPin = false;
            }
        },
        handleAccessExpired(message) {
            publicKoTatou.clearAccessToken();
            this.hasAccess = false;
            this.pinError = message || "Please enter the PIN again.";
        },
        handleSubmitted() {
            this.$router.push({ name: "publicKoTatouCompleted" });
        },
        exitForm() {
            publicKoTatou.clearAccessToken();
            this.hasAccess = false;
            this.$router.push({ name: "publicKoTatou" });
        },
    },
};
</script>

<style scoped src="../assets/styles/public-ko-tatou.css"></style>
